import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import AboutUsSection from './components/AboutUsSection';
import ServicesSection from './components/ServicesSection';
import TradingProductsSection from './components/TradingProductsSection';
import SustainabilitySection from './components/SustainabilitySection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <Hero />
      <AboutSection />
      <AboutUsSection />
      <ServicesSection />
      <TradingProductsSection />
      <SustainabilitySection />
      <ContactSection />
      <Footer />
    </div>
  );
}
